import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-minus-light',
  templateUrl: './icon-minus-light.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconMinusLightComponent {}
